// extracted by mini-css-extract-plugin
export default {"disposition-icon":"DispositionIcon-module__disposition-icon__fGufh","dispositionIcon":"DispositionIcon-module__disposition-icon__fGufh"};